function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { SelectEl } from "common/components/select";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  var _this$state$errors, _this$state$errors2, _this$state$errors3;
  const isModal = this.attr("is-modal");
  const showMP2023Branding = this.attr("mp-2023-style");
  return /* @__PURE__ */ jsx("div", { "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, !isModal && !showMP2023Branding && /* @__PURE__ */ jsx("div", { sel: ".step-title" }, "Enter Payment Info"), /* @__PURE__ */ jsx("div", { sel: ".payment-details-form", class: {
    "payment-info-border": !isModal
  } }, /* @__PURE__ */ jsx("div", { sel: ".input-row" }, /* @__PURE__ */ jsx("div", { sel: ".stripe-input.card-number" }, /* @__PURE__ */ jsx("label", { for: "cardNumber", sel: ".mp-font-size-medium" }, "Card number"), /* @__PURE__ */ jsx("div", { sel: "#cardNumber.input" }), /* @__PURE__ */ jsx("div", { sel: ".error-message" }, (_this$state$errors = this.state.errors) === null || _this$state$errors === void 0 ? void 0 : _this$state$errors.cardNumber)), /* @__PURE__ */ jsx("div", { sel: ".stripe-input.expiration" }, /* @__PURE__ */ jsx("label", { for: "cardExpiry", sel: ".mp-font-size-medium" }, "Expiration"), /* @__PURE__ */ jsx("div", { sel: "#cardExpiry.input" }), /* @__PURE__ */ jsx("div", { sel: ".error-message" }, (_this$state$errors2 = this.state.errors) === null || _this$state$errors2 === void 0 ? void 0 : _this$state$errors2.cardExpiry))), /* @__PURE__ */ jsx("div", { sel: ".input-row" }, /* @__PURE__ */ jsx("div", { sel: ".stripe-input.cvc" }, /* @__PURE__ */ jsx("label", { for: "cardCvc", sel: ".mp-font-size-medium" }, "CVV"), /* @__PURE__ */ jsx("div", { sel: "#cardCvc.input" }), /* @__PURE__ */ jsx("div", { sel: ".error-message" }, (_this$state$errors3 = this.state.errors) === null || _this$state$errors3 === void 0 ? void 0 : _this$state$errors3.cardCvc)), /* @__PURE__ */ jsx("div", { sel: ".stripe-input.country" }, /* @__PURE__ */ jsx("label", { for: "cardCountry", sel: ".mp-font-size-medium" }, "Country"), /* @__PURE__ */ jsx(SelectEl, { sel: "#cardCountry", attrs: {
    "selected-option": this.helpers.getSelectedCountry(),
    "menu-height": 300,
    "style-override": showMP2023Branding ? "mp-button {border-radius: 100px; font-family: 'Garnett';\n    font-size: 14px; letter-spacing: 0.02em; font-weight: 500;}" : ""
  }, props: {
    sections: this.helpers.getCountriesItems()
  }, on: {
    change: this.helpers.handleCountrySelectChange
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" })), this.helpers.POSTAL_CODE_COUNTRIES.has(this.state.selectedCountryCode) && /* @__PURE__ */ jsx("div", { sel: ".stripe-input.postal-code" }, /* @__PURE__ */ jsx("label", { for: "postal-code", sel: ".mp-font-size-medium" }, "Postal Code"), /* @__PURE__ */ jsx("input", { type: "text", sel: "#postal-code", class: _objectSpread({
    input: true
  }, this.state.selectedPostalCode && {
    invalid: this.state.errors.postalCode,
    complete: !this.state.errors.postalCode
  }), props: {
    value: this.state.selectedPostalCode,
    placeholder: "12345"
  }, on: {
    change: this.helpers.handlePostalCodeChange,
    input: this.helpers.handlePostalCodeInput
  } }), /* @__PURE__ */ jsx("div", { sel: ".error-message" }, this.state.errors.postalCode)))), isModal ? /* @__PURE__ */ jsx("div", { sel: ".review-btn-area.modal" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: showMP2023Branding ? ButtonTheme.MarketingSecondary : ButtonTheme.Secondary,
    size: ButtonSize.Large
  }, on: {
    click: () => this.dispatchEvent(new CustomEvent("cancel-modal"))
  } }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: showMP2023Branding ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
    size: ButtonSize.Large,
    disabled: this.helpers.disableReviewButton()
  }, on: {
    click: () => !this.helpers.disableReviewButton() && this.makeRequest()
  } }, "".concat(this.state.reviewBtnLoading ? "Processing" : "Update"))) : /* @__PURE__ */ jsx(null, null, showMP2023Branding && this.attr("show-not-charged-today") && /* @__PURE__ */ jsx("div", { sel: ".info-icon-area" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  }, sel: ".info-icon" }), /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file.")), /* @__PURE__ */ jsx("div", { sel: ".review-btn-area" }, this.attr("editing-card-info") && /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: showMP2023Branding ? ButtonTheme.MarketingSecondary : ButtonTheme.Secondary,
    size: ButtonSize.Large
  }, on: {
    click: () => this.dispatchEvent(new CustomEvent("toggle-edit-card"))
  } }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: showMP2023Branding ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
    role: "button",
    tabindex: 0,
    disabled: this.helpers.disableReviewButton(),
    size: ButtonSize.Large
  }, on: {
    click: () => !this.helpers.disableReviewButton() && this.passSubmitPB2()
  } }, "".concat(this.state.reviewBtnLoading ? "Processing" : "Review")), this.attr("show-not-charged-today") && !showMP2023Branding && /* @__PURE__ */ jsx("div", { sel: ".info-icon-area" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  }, sel: ".info-icon" }), /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file.")))));
}
